import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { API_S3 } from '../../../services/api_s3';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 2.75fr 1fr;
  gap: 1.5rem;
  height: 100%;

  @media (max-width: 1440px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }

  > aside {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  > main {
    display: flex;
    gap: 1.5rem;
    height: 100%;
    flex-direction: column;
  }
`;

export const SectionContainer0 = styled.section`
  position: relative;
  display: flex;
  width: 100%;
  gap: 2.5rem;
  border-radius: ${props => props.theme.radius.primary};
  border: 1px solid ${props => props.theme.cards.border};
  padding: 2.5rem;

  background: ${props => props.theme.cards.primary};
  //background-image: url(${API_S3}/default/shadow-green.webp);
  background-repeat: no-repeat;
  background-position: 100% 0;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  > aside {
    position: relative;
    height: 180px;
    margin: -57px 0 -41px 0;

    > img {
      height: inherit;
    }
  }

  > main {
    position: relative;
    display: flex;
    flex-direction: column;

    > h1 {
      color: ${props => props.theme.colors.white};
      font-size: 2rem;
      margin-bottom: 1rem;

      @media (max-width: 768px) {
        text-align: center;
        margin-top: 1.5rem;
      }
    }

    > p {
      color: ${props => props.theme.colors.muted};
      font-size: 1rem;
    }

    > h2 {
      color: #ffffff;
      font-size: 1rem;
      margin-bottom: 1rem;
    }
  }
`;

export const SectionContainer1 = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const SectionContainer2 = styled.section`
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 1.5rem;
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 425px) {
    grid-template-columns: 1fr;
  }
`;

export const SectionContainer4 = styled.section`
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 1.5rem;
  align-items: start;

  @media (max-width: 1440px) {
    grid-template-columns: 1fr 0.5fr;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    display: flex !important;
    flex-direction: column-reverse !important;
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }

  > div {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
`;

export const CardExamNotFound = styled(Link)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  background: ${props => props.theme.cards.primary};
  border-radius: ${props => props.theme.radius.primary};
  width: 100%;
  height: 100%;
  background-size: cover;
  overflow: hidden;
  text-decoration: none;
  
  &:hover {
    
    > main {
      transform: scale(1.10);
    }
  }
  
  > main {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(${API_S3}/default/not-exams.jpg) no-repeat center center;
    //transition: all .2s ease-in-out 0s;
    transition: all .35s cubic-bezier(0.645, 0.045, 0.355, 1);
    overflow: hidden;
  
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      inset: 0px;
      background-image: linear-gradient(to bottom, transparent 0%, #021614 88%);
      opacity: 0.90;
      transition: all .3s ease-in-out 0s;
    }
  }

  > header {
    position: relative;
    width: 100%;
    display: flex;
    z-index: 9;
  }

  > footer {
    position: relative;
    width: 100%;
    z-index: 9;
    margin-bottom: 0.75rem;

    > h2 {
      color: #ffffff;
      text-align: center;
      font-size: 2.25rem;
      margin-bottom: 1rem;
      line-height: 2.5rem;
    }

    > p {
      color: ${props => props.theme.colors.muted};
      text-align: center;
    }
  }
`;

export const GraphicContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  //box-shadow: ${props => props.theme.shadows.primary};
  border-radius: ${props => props.theme.radius.primary};
  width: 100%;
  height: 100%;

  > header {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-bottom: 1px solid ${props => props.theme.cards.border};

    > div {

      > svg {
        color: ${props => props.theme.colors.muted}80;
      }
    }

    > aside {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 0.25rem;

      > h2 {
        color: ${props => props.theme.colors.white};
        font-size: 1rem;
      }

      > p {
        color: ${props => props.theme.colors.muted};
        font-size: 12px;
        font-weight: 400;
      }
    }
  }

  > main {
    width: 100%;
    height: 100%;
    min-height: 230px;
    padding: 1.5rem;
  }
`;